"use client";

import { Show, UserButton, SignInButton } from "@clerk/nextjs";
import Link from "next/link";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import ThemeToggle from "@/components/ThemeToggle";
import { useI18n } from "@/lib/i18n";

export default function CrmLayout({ children }: { children: React.ReactNode }) {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-hf-paper text-hf-ink font-sans">
        <nav className="sticky top-0 z-50 border-b border-hf-line bg-hf-paper/80 backdrop-blur-md">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16 items-center">
              <Link
                href="/crm"
                aria-label={t.crm.nav.homeAria}
                className="flex items-center gap-2.5 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-hf-primary focus-visible:ring-offset-2 focus-visible:ring-offset-hf-paper"
              >
                <span className="inline-flex items-center justify-center w-[30px] h-[30px] rounded-[9px] bg-hf-primary">
                  <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                    <rect x="3" y="3.5" width="2.4" height="9" rx="1.2" fill="#fff" />
                    <rect x="6.8" y="0.5" width="2.4" height="15" rx="1.2" fill="#fff" />
                    <rect x="10.6" y="4.5" width="2.4" height="7" rx="1.2" fill="#fff" />
                  </svg>
                </span>
                <span className="text-[19px] font-semibold tracking-[-0.02em] text-hf-ink">
                  HireFit
                </span>
                <span className="font-mono text-[10px] font-medium uppercase tracking-[0.07em] px-1.5 py-0.5 rounded-md bg-hf-primary-soft text-hf-primary">
                  CRM
                </span>
              </Link>

              <div className="flex items-center gap-3">
                <ThemeToggle />
                <LanguageSwitcher />
                <Show when="signed-in">
                  <Link
                    href="/crm/billing"
                    aria-label="Billing and plans"
                    className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-hf-line text-hf-muted hover:text-hf-ink hover:border-hf-primary/50 hover:bg-hf-primary-soft text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-hf-primary focus-visible:ring-offset-2 focus-visible:ring-offset-hf-paper"
                  >
                    <span className="material-icons text-base" aria-hidden="true">
                      workspace_premium
                    </span>
                    <span className="hidden sm:inline">{t.crm.nav.billing}</span>
                  </Link>
                </Show>
                <Show when="signed-in">
                  <UserButton
                    appearance={{
                      elements: {
                        avatarBox: "w-9 h-9",
                      },
                    }}
                  />
                </Show>
                <Show when="signed-out">
                  <SignInButton mode="modal">
                    <button className="px-4 py-2 rounded-lg bg-hf-primary hover:bg-hf-primary-strong text-white text-sm font-medium transition-colors shadow-[0_10px_30px_-15px_rgba(20,19,15,0.25)]">
                      {t.crm.nav.signIn}
                    </button>
                  </SignInButton>
                </Show>
              </div>
            </div>
          </div>
        </nav>

        <main>{children}</main>
      </div>
  );
}
